/* Sleep LP Integrations — tab switcher */
(function () {
  'use strict';

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-int-tab]');
    var panels = root.querySelectorAll('[data-int-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (t) {
        var idx = t.dataset.intTab;
        var active = idx === String(index);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.intPanel === String(index));
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(parseInt(t.dataset.intTab, 10));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-sleep-int]').forEach(initTabs);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll && e.target.querySelectorAll('[data-sleep-int]').forEach(initTabs);
  });
})();
